export default "__VITE_ASSET__CZK9FGEv__"